<template>
  <v-app class="d-flex flex-column surfaceContainerLow ">



    <!-- Barra de Navegación Escritorio  -->
    <header>
      <meta name="description"
        content="Llega un mega concierto para el inicio de la navidad en el castillo marroquín, presentaciones en vivo de Blessd, westcol y 11 artistas en escena  "
        v-if="evento.id == 330">
      <meta name="keywords"
        content="blessd, westcol, nampa basico, lion fiah, nath, soley, fumaratto, favid valencia, new fest, muzza, miguel holguin b2b maicol suarez, nina caballero, regaetton, guaracha, tech tribal, urbano, navidad, chia, bogota, tu boleta, concierto, fiesta, planes en bogota, planes en chia, diciembre, novenas, iluminados, velitas, milenial, jovenes, sisabe, blessdoficial, las morras, palabras sobran, medallo, dos problemas, ojos azules, quien tv, ojitos rojos, mi gata, tendencia global, que duro, stiven mesa londoño, fechas, el bendito, warner music latina, jw world music, siempre blessd, trap latino, reguetón, regueton, feid, peso pluma, karol g"
        v-if="evento.id == 330">
      <meta name="author" content="ticketshop colombia comercializadora de franquicias sas" v-if="evento.id == 330">
      <TipoEventos v-if="evento" :horizontal="true" :select="evento.id_tipo_evento" :redirect="false"></TipoEventos>
      <!-- Barra de Navegación Escritorio  -->
      <v-app-bar clipped-right class="black" v-if="$vuetify.breakpoint.mdAndUp" app
        scroll-target="#scrolling-techniques-4">
        <v-container class="d-flex align-content-center ">
          <!-- Logotipo Ticket Shop -->
          <router-link :to="{ path: '/' }" class="logo-new my-auto" title="TicketShop" tag="a">
            <v-img src="/images/logo-dark.svg" max-width="48"> </v-img>
          </router-link>
          <v-spacer></v-spacer>

          <!-- Pasos de Compra -->
          <v-container class="py-0 d-flex align-center justify-center flex-sm-nowrap pr-0" height="100"
            v-if="$vuetify.breakpoint.mdAndUp">
            <v-col cols="10" sm="8">

              <!--//// Step  Mobile ////-->
              <v-stepper dark class="transparent" flat value="2">
                <v-stepper-header class="text-body-2 font-weight-medium">
                  <v-stepper-step step="1" complete>
                    Fecha del evento
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2">
                    Selección de entradas
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3">
                    Confirmar y pagar
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
          </v-container>

          <v-spacer></v-spacer>
          <!-- Avatar -->
          <v-col class="my-auto flex-grow-0 flex-shrink-1 pr-0">
            <!-- Login -->
            <v-btn v-if="!$store.state.user.accessToken" icon x-large v-on="on" class="d-flex d-md-none order-3">
              <v-avatar class="profile" color="primaryContainer" size="48">
                <router-link :to="{ path: '/login' }">
                  <v-img src="/images/avatar.svg"> </v-img>
                </router-link>
              </v-avatar>
            </v-btn>

            <!-- Usuario Logeado -->
            <v-menu transition="slide-y-transition" bottom left min-width="200px" rounded offset-y
              v-if="$store.state.user.accessToken">
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on">
                  <v-avatar class="profile" color="primaryContainer" size="48">
                    <span class="primary--text text-h5">
                      {{ usuario.nombre.substr(0, 1) }}
                    </span>
                  </v-avatar>
                </v-btn>
              </template>

              <!-- Menu Usuario -->
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <span class="onSurface--text text-h4">
                      {{ usuario.nombre }}
                    </span>
                    <p class="text-caption mt-1">
                      {{ usuario.email }}
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <router-link :to="{
                      name: 'perfil',
                    }">
                      <v-btn class="black--text" text rounded>Mi perfil
                      </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'perfil',
                      params: {
                        optPerfil: 3,
                      },
                    }" v-if="usuario.id_rol == 2">
                      <v-btn depressed rounded text>
                        Mis Compras
                      </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'contacto',
                    }">
                      <v-btn depressed rounded text>
                        Soporte
                      </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>
                    <!-- Acceso SuperUsuario -->
                    <router-link :to="{
                      name: 'misEventos',
                    }" v-if="
                      usuario.id_rol == 1 ||
                      usuario.id_rol == 4 ||
                      usuario.id_rol == 7 ||
                      usuario.id_rol == 5
                    ">
                      <v-btn depressed rounded text>
                        Mis Eventos
                      </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'PuntosVentaJefePunto',
                    }" v-if="usuario.id_rol == 7"><v-btn depressed rounded text>Puntos de Venta</v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'pagosParciales',
                    }" v-if="usuario.id_rol == 5">
                      <v-btn depressed rounded text>
                        Pagos parciales
                      </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'eventosAprobacion',
                    }" v-if="usuario.id_rol == 6">
                      <v-btn depressed rounded text>
                        <v-divider class="my-2"></v-divider>
                        Eventos aprobacion
                      </v-btn>
                    </router-link>

                    <v-btn @click.prevent="logout" rounded text>
                      <v-divider class="my-2"></v-divider>

                      Cerrar sesion
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </v-col>

        </v-container>
      </v-app-bar>


      <!-- Barra Mobile -->
      <nav class="barraNavegacionServicios black pt-2" v-if="$vuetify.breakpoint.smAndDown">
        <div class="atras">
          <v-app-bar-nav-icon x-large>
            <a :href="'/eventos/' + $route.params.evento">
              <v-icon dark x-large class="fill-height onPrimary--text">mdi-arrow-left</v-icon></a>
          </v-app-bar-nav-icon>
        </div>
        <div class="nav-info onPrimary--text">
          <v-col cols="12">

            <v-text class="d-flex text-subtitle-2 font-weight-bold">
              {{ evento.nombre }}
            </v-text>
            <span class="d-inline-flex caption text-capitalize mt-0">

              {{ evento.auditorio.nombre.toUpperCase() }}
            </span>
            <br>
            <span class="text-start caption text-capitalize mt-0">
              {{ formatFecha(evento.fecha_evento) }}
            </span>
          </v-col>
        </div>
        <div class="avatar">
          <!-- Avatar -->
          <v-col class="my-auto flex-grow-0 flex-shrink-1  mr-n4 pr-0">
            <!-- Login -->
            <v-btn v-if="!$store.state.user.accessToken" icon x-large v-on="on" class="d-flex d-md-none order-3">
              <v-avatar class="profile" color="primaryContainer" size="48">
                <router-link :to="{ path: '/login' }">
                  <v-img src="/images/avatar.svg"> </v-img>
                </router-link>
              </v-avatar>
            </v-btn>

            <!-- Usuario Logeado -->
            <v-menu transition="slide-y-transition" bottom left min-width="200px" rounded offset-y
              v-if="$store.state.user.accessToken">
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on">
                  <v-avatar class="profile" color="primaryContainer" size="48">
                    <span class="primary--text text-h5">
                      {{ usuario.nombre.substr(0, 1) }}
                    </span>
                  </v-avatar>
                </v-btn>
              </template>

              <!-- Menu Usuario -->
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <span class="onSurface--text text-h4">
                      {{ usuario.nombre }}
                    </span>
                    <p class="text-caption mt-1">
                      {{ usuario.email }}
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <router-link :to="{
                      name: 'perfil',
                    }">
                      <v-btn class="black--text" text rounded>Mi perfil
                      </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'perfil',
                      params: {
                        optPerfil: 3,
                      },
                    }" v-if="usuario.id_rol == 2">
                      <v-btn depressed rounded text>
                        Mis Compras
                      </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'contacto',
                    }">
                      <v-btn depressed rounded text>
                        Soporte
                      </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>
                    <!-- Acceso SuperUsuario -->
                    <router-link :to="{
                      name: 'misEventos',
                    }" v-if="
                      usuario.id_rol == 1 ||
                      usuario.id_rol == 4 ||
                      usuario.id_rol == 7 ||
                      usuario.id_rol == 5
                    ">
                      <v-btn depressed rounded text>
                        Mis Eventos
                      </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'PuntosVentaJefePunto',
                    }" v-if="usuario.id_rol == 7"><v-btn depressed rounded text>Puntos de Venta</v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'pagosParciales',
                    }" v-if="usuario.id_rol == 5">
                      <v-btn depressed rounded text>
                        Pagos parciales
                      </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'eventosAprobacion',
                    }" v-if="usuario.id_rol == 6">
                      <v-btn depressed rounded text>
                        <v-divider class="my-2"></v-divider>
                        Eventos aprobacion
                      </v-btn>
                    </router-link>

                    <v-btn @click.prevent="logout" rounded text>
                      <v-divider class="my-2"></v-divider>

                      Cerrar sesion
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </v-col>
        </div>

        <div class="paso"><v-progress-linear rounded background-color="primaryContainer" color="primary" height="8"
            value="75"></v-progress-linear>
          <v-sheet dark class="d-flex justify-center align-center black pt-2">
            <h6><v-btn color="primary" class="font-weight-bold text-body-2 mr-3" x-small fab>2</v-btn> Seleccion de
              puestos
            </h6>
          </v-sheet>
        </div>
      </nav>
    </header>

    <!-- Contenido -->
    <v-main class="v-main-complete surfaceContainerLow ">

      <!-- Barra Lateral Escritorio  -->

      <v-navigation-drawer v-if="$vuetify.breakpoint.mdAndUp" app clipped right>

        <section class=" sidebar surface">
          <div class=" info-evento elevation-1">
            <!-- Card con Información del Evento -->
            <div class="surfaceContainerLowest pa-2 ">

              <v-card max-width="24rem" class="rounded-lg" outlined>
                <v-row class="d-flex aling-start">
                  <!-- Imagen -->
                  <v-col cols="4" class="pa-2 ma-0 my-auto ">
                    <v-img :key="index" class="rounded-lg" v-for="(imagen, index) in evento.imagens"
                      v-show="imagen.nombre.includes('miniatura_600')" :src="imagen.url">
                    </v-img>

                  </v-col>
                  <!-- Información -->
                  <v-col cols="8" class="pa-2  d-flex flex-column">

                    <v-text class="d-flex title font-weight-bold " style="max-width: 250px;">
                      {{ evento.nombre }}
                    </v-text>
                    <v-text class="d-inline-flex caption text-capitalize mt-0" style="max-width: 250px;">

                      {{ evento.auditorio.nombre.toUpperCase() }}
                    </v-text>
                    <v-text class="text-start caption text-capitalize mt-0">
                      {{ formatFecha(evento.fecha_evento) }}
                    </v-text>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>

          <!-- Carrito lleno -->
          <section class="info-select surface" v-if="$store.state.resumenFinalizarCompra">
            <!-- Puestos -->
            <div class="info-select-number px-4">
              <!-- Numero de Puestos -->
              <v-text block class="font-weight-bold float-left">{{
                $store.state.resumenFinalizarCompra.productos.length - 1
                }} Puestos Seleccionados
              </v-text>
            </div>
            <!-- Vaciar Carito -->
            <div class="info-select-delete">
              <v-btn text class="red--text font-weight-bold float-right my-auto" @click="vaciarCarrito()">
                Vaciar Carrito
              </v-btn>

            </div>
            <!-- Resumen de compra -->
            <div class="info-select-seating">
              <v-divider></v-divider>
              <v-virtual-scroll :items="$store.state.resumenFinalizarCompra.productos" :item-height="88">
                <template v-slot:default="{ item: product, index }">
                  <v-list-item block class="selectSeat" :key="index">
                    <v-card rounded outlined class="my-2 d-flex" width="100%">
                      <v-list-item-avatar class="ml-2">
                        <v-avatar size="36" :color="product.color">

                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2" :style="{ color: product.color }">
                          <strong>{{ formatProductName(product.nombre) }}</strong>
                        </v-list-item-title>
                        <h6>{{ product.total }}</h6>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon v-if="product.id != false" @click="restar_reserva(product.id)" class="red--text mr-4"
                          right>
                          mdi-close-circle-outline
                        </v-icon>
                      </v-list-item-action>
                    </v-card>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </div>
          </section>
          <!-- Carrito vacio -->
          <section class=" d-flex flex-column justify-star align-center  my-auto " v-else>


            <v-icon class="tertiary--text" x-large>mdi-emoticon-plus-outline</v-icon>


            <v-text class="title mt-12 tertiary--text">
              Selecciona una localidad en el mapa </v-text>


          </section>
          <!-- Información del saldo total del Carrtito Escritorio -->
          <v-footer class="ma-0 pa-0 elevation-2 ">

            <v-row class="surfaceContainerLowest d-flex ">
              <!-- Total -->
              <v-col cols="12" v-if="$store.state.resumenFinalizarCompra"
                class="font-weight-medium title d-flex align-center justify-content-between"
                style="font-family: 'Cabin', sans-serif;">
                <v-text>
                  TOTAL:
                </v-text>
                <v-text>{{
                  $store.state.resumenFinalizarCompra.totalVenta
                  }}
                </v-text>
              </v-col>
              <!-- Botón Continuar Compra -->

              <v-col class="d-block">
                <!-- Botón Habilitado -->
                <router-link v-if="$store.state.resumenFinalizarCompra" :to="{ path: '/carts/' + this.evento.slug }">
                  <v-btn block rounded class="my-5 title" color="primary">
                    Continuar
                  </v-btn>
                </router-link>
                <!-- Botón deshabilidato -->
                <v-btn v-else block rounded class="my-5 title" color="primary" disabled>
                  Continuar
                </v-btn>
              </v-col>

            </v-row>

          </v-footer>
        </section>
      </v-navigation-drawer>


      <!--forma Nueva  --->
      <section class=" version-map1 " v-if="evento.metodo_venta == 1">
        <div id="select-place" class="select-place surfaceContainerLowest  order-last order-md-first">
          <!--\\\ Select Localidades escritorio /// -->
          <v-row justify="space-around" align="center" class="py-0 my-4">
            <v-col md="5" cols="12" class=" vselect my-n2 py-0">
              <v-select dense v-model="selectedLocalidad" :items="localidadesFormateadas" @change="zoomToPlace"
                :menu-props="{ top: false, offsetY: true }" hint="Selecciona tu localidad" label="Localidad"
                item-text="localidad" item-value="data_id_imp" persistent-hint return-object outlined></v-select>
            </v-col>
            <v-col class="vselect" md="5" cols="12">
              <v-select dense v-if="ilocalidad_g != null" v-model="cantselect" :items="cantidad"
                :menu-props="{ top: false, offsetY: true }" label="Cantidad de boletas" item-text="cantidad"
                persistent-hint return-object outlined></v-select>
            </v-col>
            <v-spacer col="2"></v-spacer>
          </v-row>
        </div>

        <!--\\\ Mapa completo /// -->
        <div class="select-map elevation-1 order-first ">

          <mapaventas class="d-flex align-center justify-center" ref="miComponente" @valorEnviado="actualizarValor"
            :evento="evento">
          </mapaventas>

        </div>

        <mapseats class="select-seat order-1 pl-1 pr-6" id="mapseats" v-show="isdisable" :key="idLocalidad"
          :evento="evento" :refrescarmapa="idLocalidad" :idlocalidad="idLocalidad" :idEvento="evento.id"
          :cantselect="cantselect" :monedaEvento="monedaSelectShopEvento"
          :indexMonedaSelectShopEvento="indexMonedaSelectShopEvento" :simboloMoneda="simboloMoneda"
          :monedasEvento="evento.monedas_evento" @reiniciarselect="recibirvalor" @valorlocalidad="recibirvalorlocalidad"
          :restarSelect="idunCheck" @color-selected="recibirColor">
        </mapseats>
      </section>
      <!--forma Antigua class="version-map2" --->
      <div ref="containerAntigua" class="container-antigua   mt-2" :style="containerStyle"
        v-if="evento.metodo_venta == 0">


        <v-row class="select-map2 d-flex justify-start mt-6 mt-md-0">
          <!-- Control de Zoom -->
          <transition name="fade">
            <div id=" zoomControls " class="zoomControl d-flex flex-column mt-8 mt-sm-0 " v-if="zoomFab">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="zoom-increase rounded-lg rounded-b-0" color="surfaceContainerLow" tile dark fab
                    v-bind="attrs" v-on="on" @click="increaseZoomLevel">
                    <v-icon color="outline">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Zoom in</span>
              </v-tooltip>

              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="zoom-decrease rounded-lg rounded-t-0" color="surfaceContainerLow" tile dark fab
                    style="margin-bottom: 1rem;" v-bind="attrs" v-on="on" @click="decreaseZoomLevel">
                    <v-icon color="onSurfaceVariant">mdi-minus</v-icon>
                  </v-btn>
                </template>
                <span>Zoom out</span>
              </v-tooltip>

              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="zoom-reset" color="surfaceContainerLow" fab dark v-bind="attrs" v-on="on"
                    @click="resetZoomLevel">
                    <v-icon color="outline">mdi-restore</v-icon>
                  </v-btn>
                </template>
                <span>Restablecer</span>
              </v-tooltip>
            </div>
          </transition>

          <v-col class="area_mapeadaAuditorio2 d-flex justify-center align-center" ref="picContainer">

            <img :key="keyBoletasxLocalidad" :src="evento.auditorio_mapeado.imagen" usemap="#map">

            <!--  <v-img contain class="imp-img-map" :src="evento.auditorio_mapeado.imagen" @click="mapasientos(true);" /> -->
          </v-col>
        </v-row>
        <v-row class="select-seat2" id:="boletas">
          <v-col class="d-flex justify-center">
            <BoletasxLocalidad :key="keyBoletasxLocalidad" :pagos="pagos" :fisico="false" v-if="idLocalidad != ''"
              :idlocalidad="idLocalidad" :idEvento="evento.id" :monedaEvento="monedaSelectShopEvento"
              :indexMonedaSelectShopEvento="indexMonedaSelectShopEvento" :simboloMoneda="simboloMoneda"
              :monedasEvento="evento.monedas_evento" @statuswidget="ejecutarwidget">
            </BoletasxLocalidad>
          </v-col>
        </v-row>
        <v-row class="select-functions" v-show="!mostrarmapa">

          <!-- <div
            :class="idLocalidad != '' || $store.state.funcioneshora.length > 0 ? 'col-md-12 col-lg-12 mb-12' : 'col-md-6 col-lg-6 mb-4'"> -->
          <div class="cont-mapa-asientos">





            <section class="calendario" v-if="!mostrarmapa">



              <div class="grid-container">
                <h4 class="seleccion_fecha">
                  Selecciona una Fecha
                </h4>

                <flat-pickr class="custom-calendar" v-model="selectedDate" :modelValue="selectedDate"
                  :config="flatpickrConfig"></flat-pickr>
                <div class="grid-item mt-4">
                  <v-text style="text-align: center; " class="h5 " v-if="$store.state.funcioneshora.length > 0">
                    Funciones
                    disponibles para: <br> {{ fechaselectedDate }} </v-text>
                  <div class="funcion-item d-flex flex-column flex-md-row">
                    <v-col class="d-flex justify-content-center mt-4 " v-for="item in $store.state.funcioneshora"
                      :key="item.id">
                      <div>
                        <div class="funcion__hora">
                          <v-text class="funcion__hora--text title">HORA</v-text>
                        </div>

                        <v-sheet class="funcion-detalle">
                          <h5>Desde {{ item.horainicio }}</h5>
                          <h5> Hasta {{ item.horafinaliza }} </h5>
                        </v-sheet>



                        <div>
                          <v-btn rounded block type="button" class="primary mt-2"
                            :disabled="($store.state.carrito.cantBoletaTotal !== 0 && funcionseleccionada !== item.id) || item.estado == 0"
                            @click="cargarPreciosFunciones(item.id)"> Comprar
                          </v-btn>
                        </div>

                      </div>
                    </v-col>
                  </div>

                </div>
              </div>




              <v-dialog v-model="modalVisible" max-width="500px">
                <v-card>

                  <v-col @click="cerrarModalFunciones" cols="12" class="pa-0 d-flex justify-content-end">
                    <v-btn icon large>
                      <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- <span class="headline">Valores</span>-->




                  <div style="box-shadow: 0px 10px 10px -6px  rgb(184, 179, 166); border-radius: 15px;"
                    v-for="item in $store.state.funcioneslocalidades" :key="item.id">
                    <v-text>{{ item.nombre }}</v-text>
                    <v-card-actions>
                      <v-btn outlined block rounded color="primary"
                        @click="ejecutarGetPuestos(item.id_localidad)">Seleccionar</v-btn>

                    </v-card-actions>
                  </div>








                </v-card>
              </v-dialog>



              <v-dialog v-model="dialogotablaprecios" max-width="100%">
                <v-card>
                  <v-card-title>
                    <!-- <span class="headline">Valores</span>-->
                  </v-card-title>
                  <v-card-text>


                    <img :src="evento.url_imagen" :alt="evento.nombre" v-if="evento.url_imagen">







                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="btn btn-primary" text @click="dialogotablaprecios = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>




            </section>


          </div>
          <!-- </div> -->

        </v-row>

      </div>

    </v-main>
    <v-footer class="ma-0 pa-0 surfaceContainerLowest elevation-2 "
      v-if="$vuetify.breakpoint.smAndDown && $store.state.resumenFinalizarCompra">

      <v-container>
        <!-- Información del saldo total del Carrtito Mobile  -->
        <v-row class="my-0 py-0">
          <v-col class="my-0 py-0 d-flex flex-column flex-sm-row justify-content-between align-center">
            <!-- Total -->

            <v-col sm="8"
              class="btn-panel-wrapper title  font-weight-medium ma-0 pa-0 d-flex align-center justify-content-between"
              style="font-family: 'Cabin', sans-serif;" @click="togglePanel" :class="{ activo: panelActivo }">
              <v-badge :content="$store.state.resumenFinalizarCompra.productos.length - 1" color="tertiary" overlap>
                <v-btn fab v-if="$vuetify.breakpoint.mdAndDown" icon color="primary" dark>
                  <v-icon large>mdi-ticket-outline</v-icon>
                </v-btn>
              </v-badge>
              <v-col class="d-flex flex-column text-right">
                <v-text class="title">{{
                  $store.state.resumenFinalizarCompra.totalVenta
                  }}
                </v-text>
                <v-text class="tertiary--text subtitle-1">
                  {{ panelActivo ? 'Volver al mapa' : 'Ver puestos seleccionados' }}
                </v-text>
              </v-col>
            </v-col>
            <v-col cols="12" sm="3" class="panel-wrapper my-0 py-0 d-sm-flex justify-end"
              :class="{ activo: panelActivo }">

              <router-link :to="{ path: '/carts/' + this.evento.slug }">
                <v-btn :loading="loading5" :disabled="loading5" :block="$vuetify.breakpoint.xsOnly" rounded
                  class="my-4 title" color="primary" @click="loader = 'loading5'">
                  Ir a pagar
                </v-btn>
              </router-link>

            </v-col>

          </v-col>

        </v-row>
      </v-container>
    </v-footer>
    <!-- Panel Desplegable -->
    <div class="page-container" v-if="$vuetify.breakpoint.mdAndDown">

      <transition name="fade">
        <div class="overlay-backdrop"
          v-if="panelActivo && $vuetify.breakpoint.mdAndDown && $store.state.resumenFinalizarCompra"></div>
      </transition>

      <transition name="slide-fade">
        <section class="panel-overlay background rounded-b-0 rounded-xl"
          v-if="panelActivo && $vuetify.breakpoint.mdAndDown && $store.state.resumenFinalizarCompra">
          <!-- && $store.state.resumenFinalizarCompra -->
          <!-- Contenido del panel -->
          <section class="info-evento pa-2 surfaceContainerLowest">
            <!-- Card con Información del Evento -->
            <div class="my-4">
              <v-card class="rounded-lg" outlined>
                <v-row class="d-flex align-center justify-space-between flex-nowrap">
                  <!-- Imagen -->
                  <v-col cols="4" fill-height class="pa-2">
                    <v-img v-for="(imagen, index) in evento.imagens" :key="index"
                      v-show="imagen.nombre.includes('miniatura_320')" :src="imagen.url" class="rounded-lg" />
                  </v-col>
                  <!-- Información -->
                  <v-col cols="6" class="pa-2 d-flex flex-column">
                    <span class="d-flex title font-weight-bold" style="max-width: 250px;">
                      {{ evento.nombre }}
                    </span>
                    <span class="text-start body-1 text-capitalize mt-0">
                      {{ formatFecha(evento.fecha_evento) }}
                    </span>
                  </v-col>
                  <!-- Botón para cerrar el panel (opcional) -->
                  <v-col class="align-self-start">
                    <v-btn fab x-small outlined color="tertiary" @click="togglePanel">
                      <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-card>
            </div>
          </section>
          <v-main>
            <v-container class="info-select">
              <!-- Sección de Puestos Seleccionados -->
              <v-row no-gutters class="info-select-number d-flex align-center ">
                <!-- Número de Puestos -->
                <v-col>
                  <v-text block class="subtitle-1 font-weight-bold float-left">
                    {{ $store.state.resumenFinalizarCompra.productos.length - 1 }} Puestos Seleccionados
                  </v-text>
                </v-col>
                <!-- Botón para vaciar carrito -->
                <v-col class="info-select-delete my-auto">
                  <v-btn text class="red--text font-weight-bold float-right my-auto" @click="vaciarCarrito()">
                    Vaciar Carrito
                  </v-btn>
                </v-col>

              </v-row>

              <v-col class="info-select-seating">
                <v-divider block class="py-2 my-2 "></v-divider>
                <!-- Resumen de compra -->
                <v-virtual-scroll :items="$store.state.resumenFinalizarCompra.productos" :item-height="88">
                  <template v-slot:default="{ item: product, index }">
                    <v-list-item block class="selectSeat" :key="index">
                      <v-card rounded outlined class="my-2 d-flex" width="100%">
                        <v-list-item-avatar class="ml-2">
                          <v-avatar size="36" :color="product.color"></v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          {{ product.color }}
                          <v-list-item-title class="text-body-2" :style="{ color: product.color }">
                            <strong>{{ formatProductName(product.nombre) }}</strong>
                          </v-list-item-title>
                          <h6>{{ product.total }}</h6>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon v-if="product.id != false" @click="restar_reserva(product.id)"
                            class="outline--text mr-4" right>
                            mdi-close-circle-outline
                          </v-icon>
                        </v-list-item-action>
                      </v-card>
                    </v-list-item>
                  </template>
                </v-virtual-scroll>
              </v-col>
            </v-container>
          </v-main>
        </section>
      </transition>
    </div>

  </v-app>
</template>
<script>
import TipoEventos from "./fragments/TipoEventos.vue";
import BoletasxLocalidad from "./utils/BoletasxLocalidad.vue";
import TablaEvento from "./Templates/Evento/TablaEvento";
import moment from "moment";
import mapaventas from './mapaventas.vue';
import mapseats from "./utils/Mapseats.vue";
import axios from 'axios';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/l10n/es";
import "flatpickr/dist/themes/material_red.css";
import { configApi } from '../api/configApi';
import { headers } from '../api/headers';




import _ from "lodash";
moment.locale("es");




export default {
  components: {
    TipoEventos,
    BoletasxLocalidad,
    TablaEvento,
    flatPickr,
    mapaventas,
    mapseats
  },
  data() {
    return {
      zoomFab: true,
      currentZoom: 1,
      loader: null,
      loading5: false,
      panelActivo: false,
      idunCheck: '',
      colorSelect: null,
      selectedColors: [],
      cantselect: null,
      valorlocalidad: null,
      dialogCarrito: false,
      dialog: false,
      drawer: null,
      type: "month",
      start: new Date(),
      end: new Date(),
      typeOptions: [
        { text: "Day", value: "day" },
        { text: "4 Day", value: "4day" },
        { text: "Week", value: "week" },
        { text: "Month", value: "month" },
        { text: "Custom Daily", value: "custom-daily" },
        { text: "Custom Weekly", value: "custom-weekly" },
      ],
      selectedDate: new Date(),
      seleccionado: null,
      enabledDates: [],
      fechaselectedDate: "",
      seleccionadohora: "",
      actualizarfecha: true,
      menu: false,
      acceptTyC: false,
      acceptTD: false,
      dialogotablaprecios: false,
      dataCompare: null,
      tab: "general",
      tabpreventa: 0,
      modalSelectEntregaBoletas: false,
      entregaBoletas: "digital",
      keyBoletasxLocalidad: 0,
      mostrarmapa: true,
      mostrarminimap: true,
      modalVisible: false,
      horario: [],
      /* Select Localidades */
      localidadesFormateadas: { localidad: '', precio: '', data_id_imp: '', id: '' },
      selectedLocalidad: null,
      cantidad: [],
      flatpickrStyle: {
        width: "500px",
        height: "70px",
      },
      funcionseleccionada: 0,
      ventas: [
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: "palco F.A.M.E",
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
      ],
      keyPuntoventas: "",
      headersPuntoventa: [
        {
          text: "Nombre Comercial",
          align: "left",
          value: "punto_ventum.nombre_razon",
        },
        {
          text: "Dirección",
          value: "punto_ventum.direccion",
        },
        {
          text: "Ciudad",
          value: "punto_ventum.id_ciudad",
        },
        {
          text: "Zona/Region",
          value: "punto_ventum.zona",
        },
        {
          text: "Telefono",
          value: "punto_ventum.telefono",
        },
        {
          text: "Responsable",
          value: "punto_ventum.responsable",
        },
      ],
      rowperpageitems: [5, 10, 25, { text: "Todos", value: -1 }],
      idLocalidad: "",
      dialogmapasientos: false,
      elhtml2: "",
      monedaSelectShop: null,
      activeModalAsientos: false,
      items: [],
      isdisable: false,
      ilocalidad_g: null
    };
  },
  watch: {
    async idLocalidad() {

      if (this.idLocalidad != '') {
        await this.$store.dispatch("localidad/listBoletasLocalidad", {
          id_localidad: this.idLocalidad,
          id_evento: this.evento.id,
          codigo_moneda: this.evento.monedas_evento,
        });
        /* Scroll a boletasxLocalidad */
        this.$nextTick(() => {
          const el = document.querySelector("#boletasxlocalidadcomponent");
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          } else {
            console.log('Elemento #boletasxlocalidadcomponent no encontrado');
          }
        });

        if (this.$store.getters["localidad/listBoletasLocalidadDisponibilidad"].disponibles == 0) {
          swal("¡No hay puestos disponibles para esta localidad!", "No hay puestos disponibles para esta localidad.", "warning").then(
            this.idLocalidad = ''
          )
        }

        if (this.$store.getters["localidad/listBoletasLocalidadDisponibilidad"].disponibles >= 10) {
          this.cantidad = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 111, 11111]
        } else {
          for (let index = 0; index < this.$store.getters["localidad/listBoletasLocalidadDisponibilidad"].disponibles; index++) {
            this.cantidad.push(index + 1)
          }
        }
      }
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 4000)

      this.loader = null
    },

    // evento(){
    //   this.$store.dispatch('auditorio_mapeado/listLocalidadesAuditorio_mapeado',this.evento.id_auditorio_mapeado);
    // },
    async evento() {
      this.$store.commit("evento/setImagenesEvento", null);
      if (this.evento) {
        this.$store.dispatch("evento/listPreventasEvento", this.evento.id);
        this.$store.dispatch(
          "auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado",
          this.evento.id
        );
        await this.$store.dispatch("evento/changeMonedaShopEvento", {
          codigo_moneda: this.monedaSelectShopEvento,
          evento_id: this.evento.id,
        });
        this.$store.dispatch("evento/getCondicionesEvento", this.evento.id);
        this.$store.dispatch("evento/listPreventasEvento", this.evento.id);
        this.$store.dispatch("evento/getpuntoventasEvento", this.evento.id);
        this.$store.dispatch(
          "auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado",
          this.evento.id
        );
        this.mostrarmapa = true;
        if (this.evento.id_tipo_evento == 7) {
          this.mostrarmapa = false;
        }

        if (
          this.monedaSelectShopEvento === null &&
          this.evento.monedas_evento.length > 0
        ) {
          this.$store.commit(
            "evento/changeMonedaShopEvento",
            this.evento.monedas_evento[0].codigo_moneda
          );
          this.monedaSelectShop = this.monedaSelectShopEvento;
        } else {
          this.monedaSelectShop = this.monedaSelectShopEvento;
        }
        this.$store.dispatch("evento/getImagenesEvento", this.evento.id);
        $("html, body").animate({ scrollTop: $("body").offset().top }, 1);
        this.activeModalAsientos = false;
        if (this.evento && this.evento.slug != this.$route.params.evento) {
          this.$store.dispatch(
            "auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado",
            this.evento.id
          );
          this.$store.dispatch(
            "auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado",
            this.evento.id
          );
        }
        if (this.idLocalidad && this.evento.localidades_evento) {
          let element = this.evento.localidades_evento.find(
            (e) => e.id_localidad == parseInt(this.idLocalidad)
          );
          if (!element) {
            this.idLocalidad = "";
          }
        }
        setTimeout(() => {
          this.activeModalAsientos = true;
        }, 500);
        this.keyBoletasxLocalidad += 1;
      }
      this.buscaritems()
    },
  },
  async beforeCreate() {
    this.$store.dispatch("ciudad/listCiudades");
    await this.$store.dispatch("auditorio/listAuditorios");
    //await this.$store.dispatch("evento/getEvento", this.$route.params.evento);
    await this.$store.dispatch("evento/listEventosStatus", {
      page: 1,
      status: 1,
    });

    // this.$store.dispatch('auditorio_mapeado/listLocalidadesAuditorio_mapeado',this.$store.getters['evento/evento'].id_auditorio_mapeado);
    // this.$store.dispatch('auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado', this.$route.params.evento);
    // this.$store.dispatch('auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado', this.$route.params.evento);

    if (this.evento && this.evento.status != 1 && this.evento.status != 3) {
      this.$router.push({ path: "/" });
    }

    if (this.userAuth.id_rol != null && this.userAuth.id_rol == 5) {
      this.$router.push({ name: "misEventos" });
    }

  },
  async mounted() {

    const container = this.$refs.containerAntigua; // Obtener el contenedor mediante una referencia
    if (container) {
      container.addEventListener('scroll', this.onContainerScroll);
    }

    $("html, body").animate({ scrollTop: $("body").offset().top }, 1);
    await this.onMounted();
    window.setInterval(() => {
      this.validateDateTimeSale();
    }, 3000);
    // this.mapasientos(true);

    // Obtener la estructura desde localStorage
    const estadoGuardado = localStorage.getItem("estadoVuex");

    // Asegurarse de que haya un estado guardado y establecerlo en Vuex si existe
    if (estadoGuardado) {
      this.$store.replaceState(JSON.parse(estadoGuardado));
      localStorage.removeItem("estadoVuex");
    }
    // console.log( this.$store.state);
    if (this.evento.id_tipo_evento == 7) {
      this.traerFechasFunciones();
    }

    function formatPrecio(precio) { return `$${precio.toLocaleString('es-CO')}`; }
    /* Lista las todas las tribunas */
    const tribunas = this.evento.auditorio_mapeado.tribunas;

    /* Formando los nombres del que se mostraran en el Select de localidades */
    const localidadesFormateadas = [];
    tribunas.forEach(tribuna => {
      tribuna.localidads.forEach(localidad => {
        localidadesFormateadas.push({
          precio: localidad.localidad_evento[0].precio_venta,
          data_id_imp: `${localidad.id} - ${tribuna.nombre} - ${localidad.nombre}`,
          localidad: `${tribuna.nombre} - ${localidad.nombre} - ${formatPrecio(localidad.localidad_evento[0].precio_venta)}`
        });
      });
    }); this.localidadesFormateadas = localidadesFormateadas;

  },
  beforeUpdate() {
    // document.title = `${this.evento ? this.evento.nombre : 'Evento Ticketshop'} - TicketShop`;

    if (this.evento.id == 330) {
      document.title =
        "WHITE MERRY CHRISTMAS BLESSD CASTILLO MARROQUIN 16 DICIEMBRE";
    } else {
      document.title = `${this.evento ? this.evento.nombre : "Evento Ticketshop"
        } - TicketShop`;
    }

    if (this.idLocalidad != "") {
      document.getElementsByClassName(
        "cont-mapa-asientos"
      )[0].style.backgroundImage = "";
    }
  },

  beforeDestroy() {
    const container = this.$refs.containerAntigua; // Limpiar el listener al destruir el componente
    if (container) {
      container.removeEventListener('scroll', this.onContainerScroll);
    }
  },
  updated() {
    /*if (this.elhtml2!="")
    {
      $('#btnPayU2').submit();
    }*/
  },
  async created() {


    const siexite = JSON.parse(localStorage.getItem('vuex'));
    if (siexite.user.accessToken == null) {
      var ruta = 'eventos/' + this.currentRoute + '/' + this.evento.slug
      localStorage.setItem('rutalogin', ruta)
    } else {
      localStorage.removeItem('rutalogin')
    }

    setTimeout(() => {
      this.resetZoomLevel();
    }, 1600);

    
    await this.refrescarvalorwidget()

  },
  methods: {
    onContainerScroll(e) {
      const top = e.target.scrollTop || 0; // Obtener la posición vertical del scroll
      console.log("Posición del scroll:", top);
      this.zoomFab = top < 280;
    },
    togglePanel() {
      this.panelActivo = !this.panelActivo;
    },
    // Incrementa el nivel de zoom y actualiza la imagen y las áreas
    increaseZoomLevel() {
      if (this.currentZoom < 1.7) {  // Límite máximo (ajústalo según sea necesario)
        this.currentZoom = parseFloat((this.currentZoom + 0.25).toFixed(2));
        this.zoom();
      }
    },
    // Disminuye el nivel de zoom y actualiza la imagen y las áreas
    decreaseZoomLevel() {
      if (this.currentZoom > 0.5) {  // Límite mínimo
        this.currentZoom = parseFloat((this.currentZoom - 0.25).toFixed(2));
        this.zoom();
      }
    },
    // Resetea el zoom a 1 (100%) y actualiza la imagen y las áreas
    resetZoomLevel() {
      this.currentZoom = 1;
      this.zoom();
    },
    // Aplica la escala "effectiveScale" a la imagen y recalcula las coordenadas del mapa
    zoom() {
      const container = this.$refs.picContainer;
      if (!container) return;

      const pic = container.getElementsByTagName("img")[0];
      if (!pic) return;

      // Al primer load, guarda las dimensiones naturales de la imagen
      if (!pic.oldwidth) {
        pic.oldwidth = pic.naturalWidth;
        pic.oldheight = pic.naturalHeight;
      }

      // Obtén el ancho actual del contenedor. Si la imagen se muestra al 100%,
      // el contenedor define el ancho visual de la imagen a nivel base.
      const containerWidth = container.clientWidth;

      // Calcula la escala base para que, si currentZoom es 1, la imagen se muestre a 100%
      const baseScale = containerWidth / pic.oldwidth;

      // Combina la escala base con el factor de zoom actual
      const effectiveScale = baseScale * this.currentZoom;

      // Actualiza el tamaño de la imagen usando la escala efectiva.
      // Con currentZoom igual a 1: effectiveScale = containerWidth/pic.oldwidth,
      // por lo que el ancho de la imagen será pic.oldwidth * containerWidth/pic.oldwidth = containerWidth.
      pic.style.width = (pic.oldwidth * effectiveScale) + "px";
      pic.style.height = (pic.oldheight * effectiveScale) + "px";

      // Recalcula las coordenadas de las áreas del mapa utilizando la escala efectiva
      this.scaleAllAreas(effectiveScale);
    },
    // Función para recalcular y actualizar las coordenadas de las áreas (elementos <area class="maparea">)
    scaleAllAreas(scale) {
      const container = this.$refs.picContainer;
      if (!container) return;

      const areas = container.querySelectorAll("area.maparea");
      areas.forEach((area) => {
        // Guarda las coordenadas originales en un data-attribute la primera vez
        if (!area.dataset.originalCoords) {
          area.dataset.originalCoords = area.getAttribute("coords");
        }
        // Convierte la cadena de coordenadas a un arreglo numérico
        const originalCoords = area.dataset.originalCoords.split(",").map(Number);
        // Aplica la escala a cada valor y redondea los resultados para que sean números enteros
        const newCoords = originalCoords.map(coord => Math.round(coord * scale));
        // Actualiza el atributo 'coords' del área con los nuevos valores
        area.setAttribute("coords", newCoords.join(","));
      });
    },

    vaciarCarrito() {
      swal({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        buttons: {
          cancel: "No, cancelar",
          confirm: "Sí, eliminarlo"
        },
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          // Aquí se ejecuta la función para vaciar el carrito.
          this.clearCantBoleta();

          // Se muestra el mensaje de éxito.
          swal("Exito!", "El carrito se vacio correctamente.", "success");
        } else {
          // Si se cancela la acción, se notifica al usuario.
          swal("Cancelado", "Tu carrito está seguro :)", "info");
        }
      })
    },

    logout() {
      this.$store.dispatch("logout");
    },
    zoomToPlace(selectedItem) {
      if (selectedItem) {
        const imageMapProDiv = document.getElementById('image-map-pro');
        const imageName = imageMapProDiv ? imageMapProDiv.getAttribute('data-image-map-name') : null;
        const objectTitle = selectedItem.data_id_imp;
        if (imageName) {
          ImageMapPro.focusObject(imageName, objectTitle);
        }
        else {
          console.error('No se encontró el nombre de la imagen.', imageName);
        }
        const x = selectedItem.data_id_imp.match(/\d+/)[0]

        this.actualizarValor(x)
      }
    },
    formatProductName(nombre) {

      let regex = /(Boleta \w+ \d+)/;
      let match = nombre.match(regex);
      if (match) {
        return match[1].replace(/(\d+)/, '#$1');
      } else {
        return nombre;
      }
    },
    async restar_reserva(id) {
      console.log('westoy en resa');
      

      var rr = id.split("-")


      var encontre = await this.$store.state.resumenFinalizarCompra.productos.find((productos) => productos.id == id)
      // Mostrar los productos en la consola


      this.valida_venta_estado = 0

      if (this.$store.getters["user/dataUserLogged"].nombre == null) {
        this.$router.push({ path: "/login" })
        return false;
        //swal("Error!", "Debe Iniciar Sesión!", "error");
      }

      if (
        this.currentRoute != "evento" ||
        this.evento.fechaValidaInicioInternet || this.$store.state.carrito.cuponestado
      ) {
        if (this.$store.getters["user/dataUserLogged"].nombre == null) {
          this.$router.push({ path: "/login" })
          //swal("Error!", "Debe Iniciar Sesión!", "error");
        } else {
          if (
            this.countPalcos > 0
          ) {
            // await this.$store.dispatch('carrito/listBoletas',{
            // 	id: this.boleta.id,
            // 	id_evento: this.boleta.id_evento,
            // 	id_puesto: this.boleta.id_puesto,
            //     precio_venta: this.boleta.precio_venta,
            //     precio_servicio: this.boleta.precio_servicio,
            //     impuesto: this.boleta.impuesto,
            //     status: 2,
            //     codigo_moneda: this.boleta.codigo_moneda,
            // });
            //lamt 3

            /* Acá tendría que ir la función unselectSeat */


            if (this.evento.metodo_venta != 0) {
              if (this.valorlocalidad != null) {

                if (this.valorlocalidad[0].palco != 1) {
                  const fila = JSON.parse(this.valorlocalidad[0].mapeo)

                  for (let i = 0; i < fila.length; i++) {
                    const puesto = fila[i].find(p => p.id_boleta_Evento == rr[1]);

                    if (puesto != undefined) {
                      puesto.status_boleta_Evento = 1
                      i = fila.length
                    }
                  }

                  let code = JSON.stringify(fila);

                  let codigolocalidad = this.valorlocalidad[0].localidad_id;
                  const data = {
                    id: codigolocalidad,
                    mapeo: code,
                  };

                  axios.post(`${configApi.apiUrl}ger_mapeo_localidad`, data, { headers: headers })
                    .then(response => {

                    })
                } else {
                  const fila = JSON.parse(this.valorlocalidad[0].mapeo)

                  for (let i = 0; i < fila.length; i++) {

                    const puesto = fila[i].find((palco) =>
                      palco.palcos[0].palco_eventos.find(p => p.id == rr[1]));

                    if (puesto != undefined) {
                      puesto.palcos[0].palco_eventos[0].status = 1
                      i = fila.length
                    }

                  }

                  let code = JSON.stringify(fila);

                  let codigolocalidad = this.valorlocalidad[0].localidad_id;
                  const data = {
                    id: codigolocalidad,
                    mapeo: code,
                  };

                  axios.post(`${configApi.apiUrl}ger_mapeo_localidad`, data, { headers: headers })
                    .then(response => {
                      console.log('volvi dle cambio');

                    })
                }
              }

              await this.$store
                .dispatch("evento/setCantBoleta", {
                  operacion: "restar",
                  palco: '',
                  id_evento: this.evento.id,
                  id_localidad: this.idLocalidad,
                  palco_status: 1,
                  metodo: 'nuevo'
                })
                .then((response) => {

                  this.refrescarvalorwidget();

                  this.idunCheck = rr[1] + '/' + this.valorlocalidad[0].localidad_id

                });
            } else {

              //var encontre = this.$store.state.resumenFinalizarCompra.productos.find((productos) => productos.id == id)
              


              if (encontre.info.status != 12) {
                await this.$store
                  .dispatch("evento/setCantBoleta", {
                    operacion: "restar",
                    palco: 1,
                    id_evento: this.evento.id,
                    id_localidad: this.idLocalidad,
                    palco_status: 1,
                    metodo: 'viejo',
                    idboletaopalco: rr[1]
                  })
                  .then((response) => {

                    this.refrescarvalorwidget();

                    this.idunCheck = rr[1] + '/' + this.valorlocalidad[0].localidad_id

                  });
              } else {
                await this.$store
                  .dispatch("evento/setCantBoleta", {
                    operacion: "restarIndividual",
                    palco: 1,
                    id_evento: this.evento.id,
                    id_localidad: this.idLocalidad,
                    palco_status: 1,
                    metodo: 'viejo',
                    id_palco: rr[1]
                  })
                  .then((response) => {
                    console.log('respuesta', response);
                    this.refrescarvalorwidget();

                    this.idunCheck = rr[1] + '/' + this.valorlocalidad[0].localidad_id

                  });
              }

            }


            //actualiza la grafica de las boletas
            this.$store.dispatch("localidad/listBoletasLocalidad", {
              id_localidad: this.idlocalidad,
              id_evento: this.idEvento,
              codigo_moneda: this.monedaEvento,
            });
            if (this.boleta.status != 12) {
              this.modalCosto = false;
            }
          } else {

            console.log('soy una boleta', id);
            if (rr[0] === "B") {
              if (this.evento.metodo_venta != 0) {
                await this.$store
                  .dispatch("evento/setCantBoleta", {
                    operacion: "restar",
                    palco: '',
                    id_evento: this.evento.id,
                    id_localidad: this.idLocalidad,
                    palco_status: 1,
                    metodo: 'nuevo'
                  })
                  .then((response) => {

                    this.refrescarvalorwidget();

                    this.idunCheck = rr[1] + '/' + this.valorlocalidad[0].localidad_id

                  });
              } else {

                await this.$store
                  .dispatch("evento/setCantBoleta", {
                    operacion: "restar",
                    palco: '',
                    id_evento: this.evento.id,
                    id_localidad: this.idLocalidad,
                    palco_status: 1,
                    metodo: 'viejo'
                  })
                  .then((response) => {

                    this.refrescarvalorwidget();

                    this.idunCheck = rr[1] + '/' + this.valorlocalidad[0].localidad_id

                  });
              }
            } else {

              await this.$store
                .dispatch("evento/setCantBoleta", {
                  operacion: "restarIndividual",
                  palco: 1,
                  id_evento: this.evento.id,
                  id_localidad: this.idLocalidad,
                  palco_status: 1,
                  metodo: 'viejo',
                  id_palco: rr[1]
                })
                .then((response) => {
                  console.log('respuesta', response);

                  this.refrescarvalorwidget();

                  this.idunCheck = rr[1] + '/' + this.valorlocalidad[0].localidad_id

                });

            }


            //actualiza la grafica de las boletas
            this.$store.dispatch("localidad/listBoletasLocalidad", {
              id_localidad: this.idlocalidad,
              id_evento: this.idEvento,
              codigo_moneda: this.monedaEvento,
            });
            if (this.boleta.status != 12) {
              this.modalCosto = false;
            }
          }
        }
      } else {
        this.modalfechacupos = true;
        this.fechaventa = this.formatDatetimeString(this.evento.fecha_inicio_venta_internet_formateada);
        this.fechacupon = this.formatDatetimeString(this.evento.fecha_inicio_venta_cupon_formateada);
        this.ideventocup = this.evento.id_evento;
        this.validarcupon = false;
        this.validarcuponfecha = false;
        if (this.evento.cupon == 'true') { this.validarcupon = true; }
        if (this.evento.fechaValidaInicioCuponVenta == 1) { this.validarcuponfecha = true; }
      }

    },
    recibirvalor(valor) {
      this.cantselect = valor
    },
    recibirvalorlocalidad(valor) {
      this.valorlocalidad = valor
    },
    recibirColor(colorSeat) {
      this.colorSelect = colorSeat; // Actualiza colorSelect con el nuevo color
    },
    async ejecutarwidget(valor) {
      await this.refrescarvalorwidget()
    },
    async refrescarvalorwidget() {

      var cupon = 'NA';
      if (this.currentRoute != "evento" || this.evento.fechaValidaInicioInternet) {

        if (this.$store.getters["user/dataUserLogged"].nombre == null) {
          //this.$store.state.modalLogin = true;
        } else {

          if (this.entregaBoletas != null && this.entregaBoletas != undefined) {
            
            var lasBoletas = [];
            var losPalcos = [];

            for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
              
              if (this.$store.state.carrito.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
                
                if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
                  
                    var palcosGuardados = localStorage.getItem('palcosReservadosPV')

                    console.log('palcosguardados',palcosGuardados);
                    
                    localStorage.removeItem('palcosReservadosPV')
                    let array = palcosGuardados ?JSON.parse(palcosGuardados): []
                    
                    if(localStorage.getItem('validacionpalco') != null){
                      if(localStorage.getItem('palcosReservadosPV') != null){

                        losPalcos = losPalcos.concat(
                          this.$store.state.carrito.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
                        );
                        console.log('estoy en refrsss palco', losPalcos);
                      
                        array.push(...losPalcos)

                        localStorage.setItem('palcosReservadosPV',JSON.stringify(array))
                      }
                      localStorage.removeItem('validacionpalco')
                      
                    }else{
                      losPalcos = losPalcos.concat(
                        this.$store.state.carrito.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
                      );
                      console.log('estoy en refrsss palco', losPalcos);
                    
                      array.push(...losPalcos)

                      localStorage.setItem('palcosReservadosPV',JSON.stringify(array))
                    }
                    

                      
                    
                    
                  
                } else {
                  lasBoletas = lasBoletas.concat(
                    this.$store.state.carrito.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
                  );
                }
                this.$store.state.carrito.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
              }
            }
            
            if (lasBoletas != [] || losPalcos != []) {
              
              if(localStorage.getItem('palcosReservadosPV') != null){
                losPalcos = JSON.parse(localStorage.getItem('palcosReservadosPV'))
              }

              if(localStorage.getItem('boletasReservadasPV') != null){
                lasBoletas = JSON.parse(localStorage.getItem('boletasReservadasPV'))
              }

              
              if (this.$store.state.carrito.cupon != null) {
                cupon = this.$store.state.carrito.cupon;
              }

              //Eliminar Duplicidad ID
              const duplicidadPalcos = new Set(losPalcos);
              let resultDupliPalcos = [...duplicidadPalcos];

              const duplicidadBoletas = new Set(lasBoletas);
              let resultDupliBoletas = [...duplicidadBoletas];

              await this.$store.dispatch("resumen_Boletas_compra", {
                palcos: resultDupliPalcos.length > 0 ? resultDupliPalcos : '',
                boletas: resultDupliBoletas.length > 0 ? resultDupliBoletas : '',
                cupon: cupon.length > 2 ? cupon : 'NA',
                funcionseleccionada: localStorage.getItem('funcionselected'),
                protectionValue: this.$store.state.protectionValue,
                pgwidget: this.$store.state.pgwidget,
                productId: this.$store.state.productId,
                sold: this.$store.state.sold,
              }).then(() => {
                if (this.$store.state.errorDetalleCompra) {
                  //swal("Parece que algo salio mal!", "Intentalo nuevamente", "error");
                  return '';
                } else {

                  this.$store.state.showModalFinalizarCompra = true;

                  var cantidadDinero = this.$store.state.resumenFinalizarCompra.totalVenta;
                  cantidadDinero = cantidadDinero.replace(/[^0-9,]/g, '').replace(',', '.');

                  this.numeropuestoscompra = this.$store.state.resumenFinalizarCompra.numeropuestoscompra;

                  this.valortotalcompra = this.$store.state.resumenFinalizarCompra.totalVenta;
                  this.cartsubtotal = parseFloat(cantidadDinero);

                  this.$store.state.totalValue = parseFloat(cantidadDinero);

                }
              });
            }
          } else {
            this.modalSelectEntregaBoletas = true;
          }
        }
      } else {
        swal(
          "Error!",
          "Ventas en linea disponible despues de " +
          this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          ),
          "error"
        );
      }
    },
    async actualizarValor(valor) {

      // Encuentra la tribuna que contiene la localidad con el id que coincide con el valor
      const tribuna = this.evento.auditorio_mapeado.tribunas.find((tribuna) =>
        tribuna.localidads.find((localidad) => localidad.id == valor));

      // Si se encontró una tribuna, verifica las condiciones
      if (tribuna) {
        const localidad = tribuna.localidads.find(localidad => localidad.id == valor);

        if (localidad.silleteria != 1 && localidad.palco != 1) {
          this.ilocalidad_g = valor;
          this.idLocalidad = valor;
          this.isdisable = false
          document.getElementById('mapseats').scrollIntoView({ behavior: 'smooth' })
        } else {
          this.idLocalidad = valor;
          this.isdisable = true
          this.ilocalidad_g = null
          document.getElementById('selectplace').scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        console.log('No se encontró una localidad con ese id.');
      }

      //this.getPuestos(valor, null);
    },
    buscaritems() {
      this.items = []
      this.items = [
        {
          text: "Inicio",
          disabled: false,
          path: "/",
        },
        {
          text: "Eventos",
          disabled: false,
          path: "/",
        }
      ]
      this.items.push({ text: this.evento.nombre, disabled: false, path: "" })
    },
    miFuncion(selectedDates, dateStr, instance) {
      this.$store.dispatch("carrito/getfuncioneshora", {
        id_evento: this.evento.id,
        fecha: dateStr,
      });
      this.selectedDate = dateStr;
      this.fechaselectedDate = dateStr;
    },

    async traerFechasFunciones() {
      this.$store.state.fechafunciones = null;
      await this.$store.dispatch("carrito/getfechafunciones", {
        id: this.evento.id,
      });

      // this.cambiarFecha();
    },
    cambiarFecha: _.once(function () {
      window.setInterval(() => {
        this.actualizarfecha = false;
        //  if(!this.actualizarfecha )  {

        let fechaDada = new Date(this.evento.fecha_evento);
        let fechaActual = new Date();
        fechaDada.setHours(0, 0, 0, 0);
        fechaActual.setHours(0, 0, 0, 0);
        if (fechaDada > fechaActual) {
          this.fechaselectedDate = fechaDada;
          this.selectedDate = fechaDada; // Actualizar el valor del campo de fecha
        }
        // this.selectedDate = this.evento.fecha_evento; // Actualizar el valor del campo de fecha
      }, 1000);

      //  }
    }),

    async cargarPreciosFunciones(id) {
      this.modalVisible = true;
      this.$store.state.funcioneslocalidades = null;
      this.funcionseleccionada = id;
      await this.$store.dispatch("carrito/getfuncioneslocalidades", {
        id: id,
      });
    },

    cerrarModalFunciones() {
      this.modalVisible = false;
    },
    ejecutarGetPuestos(id) {
      var self = this;
      self.getPuestos(id, null);
      window.location.hash = "boletas";
    },
    async handleDateClick(date) {
      await this.$store.dispatch("carrito/getfuncioneshora", {
        id_evento: this.evento.id,
        fecha: this.selectedDate,
      });
    },
    async onMounted() {
      var self = this;
      await this.$store.dispatch("evento/getEvento", this.$route.params.evento);

      //$('.carousel').height($('.cont-desc-evento').height());

      var self = this;
      setTimeout(() => {
        $(".area_mapeadaAuditorio2").append(
          $("<textarea />")
            .html(
              self.$store.getters["evento/evento"].auditorio_mapeado
                .area_mapeada
            )
            .text()
            .replace("&nbsp;", "")
        );
        $(".maparea").click(function (e) {
          e.preventDefault();
          var texthref = e.currentTarget.href;
          var arrayhref = texthref.split("/");
          self.getPuestos(arrayhref[arrayhref.length - 1], null);
          window.location.hash = "boletas";


        });
      });
      this.zoom();
    },
    async clearCantBoleta() {

      let bolet = JSON.parse(localStorage.getItem("boletasReservadasPV"))

      this.isdisable = false

      if (this.evento.metodo_venta == 1) {
        for (let k = 0; k < bolet.length; k++) {

          let idevento = this.evento.id;
          let boletaopalco = bolet[k];
          const data = {
            id: idevento,
            idboletaopalco: boletaopalco,
          };

          await axios.post(`${configApi.apiUrl}buscar_puesto_localidad`, data, { headers: headers })
            .then(response => {

              this.valorlocalidad = response.data.resultados

              if (this.valorlocalidad != null) {
                for (let index = 0; index < this.valorlocalidad.length; index++) {

                  if (this.valorlocalidad[index].palco != 1) {
                    const fila = JSON.parse(this.valorlocalidad[index].mapeo)

                    for (let j = 0; j < fila.length; j++) {
                      const puesto = fila[j].find(p => p.id_boleta_Evento == bolet[k]);

                      if (puesto != undefined) {
                        puesto.status_boleta_Evento = 1
                        j = fila.length
                      }
                    }

                    let code = JSON.stringify(fila);

                    let codigolocalidad = this.valorlocalidad[0].localidad_id;
                    const data = {
                      id: codigolocalidad,
                      mapeo: code,
                    };

                    axios.post(`${configApi.apiUrl}ger_mapeo_localidad`, data, { headers: headers })
                      .then(response => {
                        console.log('volvi dle cambio');
                      })
                  } else {
                    const fila = JSON.parse(this.valorlocalidad[index].mapeo)

                    for (let i = 0; i < fila.length; i++) {

                      const puesto = fila[i].find((palco) =>
                        palco.palcos[0].palco_eventos.find(p => p.id == bolet[k]));

                      if (puesto != undefined) {
                        puesto.palcos[0].palco_eventos[0].status = 1
                        i = fila.length
                      }
                    }

                    let code = JSON.stringify(fila);

                    let codigolocalidad = this.valorlocalidad[0].localidad_id;
                    const data = {
                      id: codigolocalidad,
                      mapeo: code,
                    };

                    axios.post(`${configApi.apiUrl}ger_mapeo_localidad`, data, { headers: headers })
                      .then(response => {
                        console.log('volvi dle cambio');

                      })
                  }
                }
              }
            })
        }
      }




      this.$store.state.carrito.descuentocupon = 0;
      this.$store.state.carrito.cuponestado = 0;
      this.$store.state.carrito.vservicio = 0;
      this.$store.state.carrito.cupon = "";
      this.$store.state.carrito.cuponok = false;
      this.$store.state.funcioneshora = [];
      localStorage.removeItem("funcionselected");
      localStorage.removeItem("boletasReservadasPV");
      localStorage.removeItem("palcosReservadosPV");
      localStorage.removeItem("validacionpalco");
      localStorage.removeItem("mantenerParticipantes");
      if (this.preciosBoletasCarrito && this.preciosBoletasCarrito.length > 0) {
        var lasBoletas = [];
        var losPalcos = [];

        for (
          var i = 0;
          i < this.listLocalidadesEventoAuditorio_mapeado.length;
          i++
        ) {
          if (
            this.cantBoleta[
            this.listLocalidadesEventoAuditorio_mapeado[i].id
            ] != null
          ) {
            if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
              losPalcos = losPalcos.concat(
                this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
                ]
              );
              
              
            } else {
              lasBoletas = lasBoletas.concat(
                this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
                ]
              );
            }
            this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
              .length;
          }
        }





        await this.$store.dispatch("carrito/setNullReservas", {
          boletas: lasBoletas,
          palcos: losPalcos,
        });

        this.idLocalidad = "";
        this.$store.dispatch("evento/clearCantBoleta");
        this.$store.dispatch("carrito/setNullPreciosBoletasCarrito");
        this.$store.dispatch("carrito/dateTimeSaleStart", null);
        this.$store.dispatch("carrito/dateTimeSaleEnd", null);
        swal("Exito!", "El carrito se vacio correctamente.", "success");
      } else {
        var lasBoletas = [];
        var losPalcos = [];
        this.idLocalidad = "";
        this.$store.dispatch("evento/clearCantBoleta");
        swal("Informacion", "El carrito esta vacio.", "info");
      }

      this.refrescarvalorwidget();
    },
    dateTimeToDate(datetime) {
      if (datetime != null && datetime != "") {
        return moment(datetime).format("YYYY/MM/DD");
      } else {
        return "";
      }
    },
    formatFecha(fecha) {
      if (fecha != null && fecha != "") {
        return moment(fecha).format("MMMM, DD YYYY");
      } else {
        return "";
      }
    },
    formatTime(time) {
      if (time != null && time != "") {
        return moment(time, "HH:mm:ss").format("LT");
      } else {
        return "";
      }
    },
    formatDatetimeString(datetime) {
      if (datetime != null && datetime != "") {
        return moment(datetime).format(
          "dddd Do [de] MMMM [del] YYYY [a las] h:m a"
        );
      } else {
        return "";
      }
    },
    formatNumber(number) {
      return new Intl.NumberFormat("es-CO", {
        minimumFractionDigits: 0,
      }).format(number);
    },
    getCiudad(id) {
      let filter_ciudad = this.ciudades.filter((ciudad) => ciudad.id == id);
      if (filter_ciudad[0] == "" || filter_ciudad[0] == null) {
        return "";
      } else {
        return filter_ciudad[0].descripcion;
      }
    },
    getPuestos(id, localidad) {
      if (this.evento && this.evento.status === 3) {
        return false;
      }

      this.idLocalidad = id;
      if (localidad === null) {
        var localidadFilter = null;
        if (
          this.listLocalidadesEventoAuditorio_mapeado &&
          this.listLocalidadesEventoAuditorio_mapeado.length > 0
        ) {
          localidadFilter = this.listLocalidadesEventoAuditorio_mapeado.filter(
            (item) => item.id == id
          );
          this.$store.dispatch(
            "carrito/localidadSelectCarrito",
            localidadFilter
          );
        }
      } else {
        this.$store.dispatch("carrito/localidadSelectCarrito", localidad);
      }
    },
    getAuditorio(id) {
      let filter_auditorio = [];
      if (this.auditorios) {
        filter_auditorio = this.auditorios.filter(
          (auditorio) => auditorio.id == id
        );
      }
      if (filter_auditorio[0] == "" || filter_auditorio[0] == null) {
        return "";
      } else {
        return filter_auditorio[0].nombre;
      }
    },
    async mapasientos(mostrar) {
      if (mostrar) {
        await this.$store.commit("evento/setEvento", this.evento);
      }
      this.dialogmapasientos = mostrar;
    },

    enviaraCarrito() {
      var lasBoletas = [];
      var losPalcos = [];
      if (this.preciosBoletasCarrito && this.preciosBoletasCarrito.length > 0) {
        for (
          var i = 0;
          i < this.listLocalidadesEventoAuditorio_mapeado.length;
          i++
        ) {
          if (
            this.cantBoleta[
            this.listLocalidadesEventoAuditorio_mapeado[i].id
            ] != null
          ) {
            if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
              losPalcos = losPalcos.concat(
                this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
                ]
              );
            } else {
              lasBoletas = lasBoletas.concat(
                this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
                ]
              );
            }
            this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
              .length;
          }
        }
      }

      if (lasBoletas.length > 0 || losPalcos.length > 0) {
        this.$store.state.newboletasclear = lasBoletas;
        this.$store.state.newpalcosclear = losPalcos;
        localStorage.setItem("newboletasclear", JSON.stringify(lasBoletas));
        localStorage.setItem("newpalcosclear", JSON.stringify(losPalcos));
        localStorage.setItem("estadoVuex", JSON.stringify(this.$store.state));
        localStorage.setItem("funcionselected", this.funcionseleccionada);
        // console.log( this.$store.state);
        window.location.href = "/carts/" + this.evento.slug;
        // this.$router.replace('/carts/'+ this.evento.slug);
        //  this.$router.push('/carts/'+ this.evento.slug);
      } else {
        swal("Informacion", "El carrito está vacío.", "info");
        return;
      }
    },
    async verResumenCompra() {
      var cupon = "NA";
      if (
        this.currentRoute != "evento" ||
        this.evento.fechaValidaInicioInternet
      ) {
        if (this.$store.getters["user/dataUserLogged"].nombre == null) {
          this.$router.push({ path: "/login" })
        } else {
          if (this.$store.state.carrito.cantBoletaTotal == 0) {
            swal("Carrito Vacio!", "No ha reservado boletas!", "success");
          } else {
            if (
              this.entregaBoletas != null &&
              this.entregaBoletas != undefined
            ) {
              var lasBoletas = [];
              var losPalcos = [];

              for (
                var i = 0;
                i < this.listLocalidadesEventoAuditorio_mapeado.length;
                i++
              ) {
                if (
                  this.$store.state.carrito.cantBoleta[
                  this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ] != null
                ) {
                  if (
                    this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1
                  ) {
                    losPalcos = losPalcos.concat(
                      this.$store.state.carrito.cantBoleta[
                      this.listLocalidadesEventoAuditorio_mapeado[i].id
                      ]
                    );
                  } else {
                    lasBoletas = lasBoletas.concat(
                      this.$store.state.carrito.cantBoleta[
                      this.listLocalidadesEventoAuditorio_mapeado[i].id
                      ]
                    );
                  }
                  this.$store.state.carrito.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ].length;
                }
              }
              if (lasBoletas != [] || losPalcos != []) {
                if (this.$store.state.carrito.cupon != null) {
                  cupon = this.$store.state.carrito.cupon;
                }

                //Eliminar Duplicidad ID
                const duplicidadPalcos = new Set(losPalcos);
                let resultDupliPalcos = [...duplicidadPalcos];

                const duplicidadBoletas = new Set(lasBoletas);
                let resultDupliBoletas = [...duplicidadBoletas];

                await this.$store
                  .dispatch("detalle_Boletas_Finalizarcompra", {
                    palcos:
                      resultDupliPalcos.length > 0 ? resultDupliPalcos : "",
                    boletas:
                      resultDupliBoletas.length > 0 ? resultDupliBoletas : "",
                    cupon: cupon.length > 2 ? cupon : "NA",
                  })
                  .then(() => {
                    if (this.$store.state.errorDetalleCompra) {
                      swal(
                        "Parece que algo salio mal!",
                        "Intentalo nuevamente",
                        "error"
                      );
                      return "";
                    } else {
                      this.$store.state.showModalFinalizarCompra = true;
                    }
                  });
              } else if (lasBoletas == [] && losPalcos == []) {
                swal("Carrito Vacio!", "No ha reservado boletas!", "success");
                return "";
              }
            } else {
              this.modalSelectEntregaBoletas = true;
            }
          }
        }
      } else {
        swal(
          "Error!",
          "Ventas en linea disponible despues de " +
          this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          ),
          "error"
        );
      }
    },
    async pagar() {
      var cupon = "NA";

      if (this.evento.id_tipo_evento == 7 && this.funcionseleccionada == 0) {
        swal(
          "Funcion no Selecciona!",
          "Algo salió mal. Limpiar el carrito e iniciar de nuevo!",
          "success"
        );
      } else {
        if (
          this.currentRoute != "evento" ||
          this.evento.fechaValidaInicioInternet
        ) {
          if (this.$store.getters["user/dataUserLogged"].nombre == null) {
            this.$router.push({ path: "/login" })
            //swal("Error!", "Debe Iniciar Sesión!", "error");
          } else {
            if (this.$store.state.carrito.cantBoletaTotal == 0) {
              swal("Carrito Vacio!", "No ha reservado boletas!", "success");
            } else {
              if (
                this.entregaBoletas != null &&
                this.entregaBoletas != undefined
              ) {
                var lasBoletas = [];
                var losPalcos = [];

                for (
                  var i = 0;
                  i < this.listLocalidadesEventoAuditorio_mapeado.length;
                  i++
                ) {
                  if (
                    this.$store.state.carrito.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                    ] != null
                  ) {
                    if (
                      this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1
                    ) {
                      losPalcos = losPalcos.concat(
                        this.$store.state.carrito.cantBoleta[
                        this.listLocalidadesEventoAuditorio_mapeado[i].id
                        ]
                      );
                    } else {
                      lasBoletas = lasBoletas.concat(
                        this.$store.state.carrito.cantBoleta[
                        this.listLocalidadesEventoAuditorio_mapeado[i].id
                        ]
                      );
                    }
                    this.$store.state.carrito.cantBoleta[
                      this.listLocalidadesEventoAuditorio_mapeado[i].id
                    ].length;
                  }
                }
                if (lasBoletas != [] && losPalcos == []) {
                  if (this.$store.state.carrito.cupon != null) {
                    cupon = this.$store.state.carrito.cupon;
                  }
                  await this.$store.dispatch("obtener_refventa", {
                    boletas: lasBoletas,
                    moneda: this.$store.getters["evento/monedaSelectShop"],
                    email: this.$store.getters["user/dataUserLogged"].email,
                    nombre: this.$store.getters["user/dataUserLogged"].nombre,
                    identificacion:
                      this.$store.getters["user/dataUserLogged"].identificacion,
                    tipo_identificacion:
                      this.$store.getters["user/dataUserLogged"]
                        .tipo_identificacion,
                    entrega_boletas: this.entregaBoletas,
                    cupon: cupon.length > 2 ? cupon : "NA",
                    funcionseleccionada: this.funcionseleccionada,
                  });
                  this.$store.state.carrito.descuentocupon = 0;
                  this.$store.state.carrito.cuponestado = 0;
                  this.$store.state.carrito.vservicio = 0;
                  this.$store.state.carrito.cupon = "";
                  this.$store.state.carrito.cuponok = false;
                } else if (lasBoletas == [] && losPalcos != []) {
                  if (this.$store.state.carrito.cupon != null) {
                    cupon = this.$store.state.carrito.cupon;
                  }
                  await this.$store.dispatch("obtener_refventa", {
                    palcos: losPalcos,
                    moneda: this.$store.getters["evento/monedaSelectShop"],
                    email: this.$store.getters["user/dataUserLogged"].email,
                    nombre: this.$store.getters["user/dataUserLogged"].nombre,
                    identificacion:
                      this.$store.getters["user/dataUserLogged"].identificacion,
                    tipo_identificacion:
                      this.$store.getters["user/dataUserLogged"]
                        .tipo_identificacion,
                    entrega_boletas: this.entregaBoletas,
                    cupon: cupon.length > 2 ? cupon : "NA",
                    funcionseleccionada: this.funcionseleccionada,
                  });
                  this.$store.state.carrito.descuentocupon = 0;
                  this.$store.state.carrito.cuponestado = 0;
                  this.$store.state.carrito.vservicio = 0;
                  this.$store.state.carrito.cupon = "";
                  this.$store.state.carrito.cuponok = false;
                } else if (lasBoletas != [] && losPalcos != []) {
                  if (this.$store.state.carrito.cupon != null) {
                    cupon = this.$store.state.carrito.cupon;
                  }
                  await this.$store.dispatch("obtener_refventa", {
                    boletas: lasBoletas,
                    palcos: losPalcos,
                    moneda: this.$store.getters["evento/monedaSelectShop"],
                    email: this.$store.getters["user/dataUserLogged"].email,
                    nombre: this.$store.getters["user/dataUserLogged"].nombre,
                    identificacion:
                      this.$store.getters["user/dataUserLogged"].identificacion,
                    tipo_identificacion:
                      this.$store.getters["user/dataUserLogged"]
                        .tipo_identificacion,
                    entrega_boletas: this.entregaBoletas,
                    cupon: cupon.length > 2 ? cupon : "NA",
                    funcionseleccionada: this.funcionseleccionada,
                  });
                  this.$store.state.carrito.descuentocupon = 0;
                  this.$store.state.carrito.cuponestado = 0;
                  this.$store.state.carrito.vservicio = 0;
                  this.$store.state.carrito.cupon = "";
                  this.$store.state.carrito.cuponok = false;
                  this.$store.state.funcioneshora = [];
                } else if (lasBoletas == [] && losPalcos == []) {
                  swal("Carrito Vacio!", "No ha reservado boletas!", "success");
                  return "";
                }

                if (this.$store.getters["get_init_point"] != null) {
                  this.idLocalidad = "";
                  await this.$store.dispatch("evento/clearCantBoleta");
                  await this.$store.dispatch(
                    "carrito/setNullPreciosBoletasCarrito"
                  );
                  await this.$store.dispatch("carrito/dateTimeSaleStart", null);
                  await this.$store.dispatch("carrito/dateTimeSaleEnd", null);
                  window.location.href = this.$store.getters["get_init_point"];
                }
              } else {
                this.modalSelectEntregaBoletas = true;
              }

              //var refventa = this.$store.getters['obtener_refventa'].refVenta;

              //var total = this.$store.getters['obtener_refventa'].precio_total;

              //var moneda = this.listLocalidadesEventoAuditorio_mapeado[0].localidad_evento[0].codigo_moneda;
              //var moneda = this.$store.getters['evento/monedaSelectShop'];

              //await this.$store.dispatch('generarsha',{
              //  moneda: moneda,
              //  refventa: refventa
              //});

              /* var usuario = this.$store.getters['user/dataUserLogged'];
               var info_pago = this.$store.getters['sha'];
  
               this.elhtml2 = '<input type="image" src="https://paymentsbakery.co/gateway/images/payments-bakery.png" border="0" alt="payments-bakery">\
               <input name="usuarioId" type="hidden" value="'+info_pago.usuarioId+'">\
               <input name="firma" type="hidden" value="'+info_pago.firma_codificada+'">\
               <input name="descripcion" type="hidden" value="'+'descripcion'+'">\
               <!-- Descripcon de la Venta Productos-->\
               <input name="refVenta" type="hidden" value="'+info_pago.refVenta+'">\
               <!--  Referencia de Venta Numero de 6 digitos -->\
               <input name="valor" type="hidden" value="'+total+'">\
               <!--  Valor de la Compra -->\
               <input name="moneda" type="hidden" value="'+moneda+'">\
               <!--  Moneda de la Compra:  PERU:  604 soles y 840 dolares. COLOMBIA COP -->\
               <input name="lang" type="hidden" value="SP">\
               <!--  lenguage   SP - Español   EN - Ingles-->\
               <input name="extra1" type="hidden" value="'+'datosCompra'+'">\
               <input name="extra2" type="hidden" value="'+'datosCompra'+'">\
               <input name="extra3" type="hidden" value="'+'datosCompra'+'">\
               <input name="url_respuesta" type="hidden" value="'+info_pago.URLRespuesta+'">\
               <input name="url_confirmacion" type="hidden" value="'+info_pago.URLConfirma+'">\
               <input name="emailComprador" type="hidden" value="'+usuario.email+'"/>\
               <input name="Comprador" type="hidden" value="'+usuario.nombre+'"  />\
               <!--  Nombre Comprador -->\
               <input name="documentoIdentificacion" type="hidden" value="'+'10628701'+'"  />\
               <!--  Documento de Identidad Comprador -->\
               <input name="Test" type="hidden" value="1"/>';
               */
            }
          }
        } else {
          swal(
            "Error!",
            "Ventas en linea disponible despues de " +
            this.formatDatetimeString(
              this.evento.fecha_inicio_venta_internet_formateada
            ),
            "error"
          );
        }
      }
    },
    getPreventa(index) {
      switch (index) {
        case -1:
          this.accion = "Aprobar";
          break;
        case 1:
          this.accion = "Aprobar";
          break;
        case 2:
          this.accion = "Rechazar";
          break;
        case 4:
          this.accion = "Aprobar Con Modificaciones";
          break;
      }
    },
    getLocalidadDescuento(localidad, preventa) {
      var total =
        parseFloat(
          eval(
            "localidad.localidad_evento[0].precio_venta" +
            this.indexMonedaSelectShopEvento
          )
        ) +
        parseFloat(
          eval(
            "localidad.localidad_evento[0].precio_servicio" +
            this.indexMonedaSelectShopEvento
          )
        );

      if (preventa) {
        if (
          preventa.id_localidad == localidad.id ||
          preventa.id_tribuna == localidad.id_tribuna ||
          preventa.id_evento == this.evento.id
        ) {
          if (preventa.precios_monedas) {
            var precioMonedaActual = preventa.precios_monedas.filter(
              (item) => item.codigo_moneda === this.monedaSelectShopEvento
            )[0];

            if (precioMonedaActual) {
              if (precioMonedaActual.descuento_fijo_servicio) {
                total =
                  parseFloat(total) -
                  parseFloat(precioMonedaActual.descuento_fijo_servicio);
              } else if (preventa.porcentaje_descuento_servicio) {
                total =
                  parseFloat(total) -
                  (parseFloat(
                    eval(
                      "localidad.localidad_evento[0].precio_servicio" +
                      this.indexMonedaSelectShopEvento
                    )
                  ) *
                    parseFloat(preventa.porcentaje_descuento_servicio)) /
                  100;
              }
              if (precioMonedaActual.descuento_fijo_precio) {
                total =
                  parseFloat(total) -
                  parseFloat(precioMonedaActual.descuento_fijo_precio);
              } else if (preventa.porcentaje_descuento_precio) {
                total =
                  parseFloat(total) -
                  (parseFloat(
                    eval(
                      "localidad.localidad_evento[0].precio_venta" +
                      this.indexMonedaSelectShopEvento
                    )
                  ) *
                    parseFloat(preventa.porcentaje_descuento_precio)) /
                  100;
              }
            }
          }
        }
      }
      return total + (total * localidad.localidad_evento[0].impuesto) / 100 <= 0
        ? 0
        : this.formatNumber(
          total + (total * localidad.localidad_evento[0].impuesto) / 100
        );
    },
    getPrecioServicioLocalidad(localidad) {
      var precio_servicio = parseFloat(
        eval(
          "localidad.localidad_evento[0].precio_servicio" +
          this.indexMonedaSelectShopEvento
        )
      );

      return this.formatNumber(precio_servicio);
    },
    getPrecioVentaLocalidad(localidad) {
      var precio_servicio = parseFloat(
        eval(
          localidad.localidad_evento[0].precio_venta +
          this.indexMonedaSelectShopEvento
        )
      );
      return this.formatNumber(precio_servicio);
    },
    changeMonedaShopEvento() {
      this.$store.dispatch("evento/changeMonedaShopEvento", {
        codigo_moneda: this.monedaSelectShop,
        evento_id: this.evento.id,
      });
      this.$router.go(this.$router.currentRoute);
    },
    concatTextMoneda(item) {
      return `(${item.moneda.simbolo}) ${item.moneda.descripcion}`;
    },
    validateDateTimeSale() {
      let fecha = new Date();
      if (this.dateTimeSaleStart != null && this.dateTimeSaleEnd != null) {
        if (this.getBrowser.includes("Safari")) {
          swal("Safari Mode", "Modo Safari", "info");
        }

        if (
          Date.parse(fecha) >= Date.parse(this.dateTimeSaleStart) &&
          Date.parse(fecha) <= Date.parse(this.dateTimeSaleEnd)
        ) {
        } else {
          if (this.dateTimeSaleStart) {
            localStorage.removeItem("mantenerParticipantes");
            localStorage.removeItem("newboletasclear");
            localStorage.removeItem("boletasReservadasPV");
            localStorage.removeItem("palcosReservadosPV");
            localStorage.removeItem("validacionpalco");
            this.$store.state.showModalFinalizarCompra = false;
            this.$store.state.resumenFinalizarCompra = null;
            this.idLocalidad = "";
            this.$store.dispatch("carrito/dateTimeSaleStart", null);
            this.$store.dispatch("carrito/dateTimeSaleEnd", null);
            this.$store.dispatch("carrito/setNullPreciosBoletasCarrito");
            this.$store.dispatch("evento/clearCantBoleta");
            localStorage.removeItem("estadoVuex");
            swal("Informacion", "El carrito esta vacio.", "info");
          }
        }
      }
    },
    getBrowser() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(" ");
    },
    formatFechaClasic(fecha) {
      if (fecha != null && fecha != "") {
        return moment(fecha).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
  },
  computed: {
    containerStyle() {

      if (this.$vuetify.breakpoint.smAndDown && this.$store.state.resumenFinalizarCompra) {
        // Verificar el ancho de la ventana
        const windowWidth = window.innerWidth;

        if (windowWidth >= 601 && windowWidth <= 960) {
          return {
            bottom: '10.5rem',
            height: 'calc(100% - 18rem)' // Para rango entre 601px y 960px
          };
        } else {
          return {
            bottom: '10.5rem',
            height: 'calc(100% - 22.625rem)' // Para otros tamaños dentro de smAndDown
          };
        }
      } else if (this.$vuetify.breakpoint.smAndDown && !this.$store.state.resumenFinalizarCompra) {
        return {
          bottom: '10.5rem',
          height: 'calc(100% - 10rem)'
        };
      }

      else {
        return {
          bottom: '0',
          height: '100%'
        };
      }
    },
    usuario() {
      return this.$store.getters["user/dataUserLogged"];
    },
    flatpickrConfig() {
      return {
        inline: true,
        locale: "es",
        enable: this.$store.state.fechafunciones,
        onChange: this.miFuncion,
      };
    },
    pagos() {
      if (this.evento && this.evento.status == 1) {
        return true;
      } else {
        return false;
      }
    },
    hoy() {
      return moment().format("Y-MM-DD");
    },
    cantBoleta() {
      return this.$store.getters["evento/cantBoleta"];
    },
    cantBoletaTotal() {
      return this.$store.getters["evento/cantBoletaTotal"];
    },
    ciudades() {
      return this.$store.getters["ciudad/listCiudades"];
    },
    evento() {
      return this.$store.getters["evento/evento"];
    },
    condicionesEvento() {
      return this.$store.getters["evento/condicionesEvento"];
    },
    preventasEvento() {
      return this.$store.getters["evento/listPreventasEvento"];
    },
    showEventosDestacados() {
      return this.$store.getters["evento/listEventosDestacados"];
    },
    eventosDestacados() {
      return this.showEventosDestacados.slice(0, 4);
    },
    imagenesEvento() {
      return this.$store.getters["evento/imagenesEvento"];
    },
    userAuth() {
      return this.$store.getters["user/dataUserLogged"];
    },
    puntoventasEvento() {
      return this.$store.getters["evento/puntoventasEvento"];
    },
    // listLocalidadesAuditorio_mapeado() {
    //   return this.$store.getters['auditorio_mapeado/listLocalidadesAuditorio_mapeado'];
    // },
    listLocalidadesEventoAuditorio_mapeado() {
      return this.$store.getters[
        "auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado"
      ];
    },
    mapaauditorio() {
      if (
        this.evento.auditorio.latitud != "" &&
        this.evento.auditorio.longitud != ""
      ) {
        return (
          "https://maps.google.com/?ll=" +
          this.evento.auditorio.latitud +
          "," +
          this.evento.auditorio.longitud +
          "&z=14&t=m&output=embed"
        );
      } else {
        return "";
      }
    },
    auditorios() {
      return this.$store.getters["auditorio/listAuditorios"];
    },
    // boletas(){
    //   return this.$store.getters['carrito/listBoletas'];
    // },
    imagenesEventoCarousel() {
      let imagenesEventoCarouselShow = [];
      if (this.imagenesEvento) {
        imagenesEventoCarouselShow = this.imagenesEvento.filter((imagen) => {
          return imagen.imagen.nombre.includes("banner");
        });
      }
      return imagenesEventoCarouselShow;
    },
    monedaSelectShopEvento() {
      return this.$store.getters["evento/monedaSelectShop"];
    },
    indexMonedaSelectShopEvento() {
      if (this.evento.monedas_evento && this.evento.monedas_evento.length > 0) {
        var index = this.evento.monedas_evento.findIndex(
          (moneda) => moneda.codigo_moneda === this.monedaSelectShopEvento
        );
        if (index === 0) {
          return "";
        } else {
          return index + 1;
        }
      }
    },
    simboloMoneda() {
      if (
        this.indexMonedaSelectShopEvento === "" ||
        this.indexMonedaSelectShopEvento === 0
      ) {
        return this.evento ? this.evento.monedas_evento[0].moneda.simbolo : "";
      } else {
        return this.evento
          ? this.evento.monedas_evento[this.indexMonedaSelectShopEvento - 1]
          : "".moneda.simbolo;
      }
    },
    preciosBoletasCarrito() {
      return this.$store.getters["carrito/preciosBoletasCarrito"];
    },
    totalValorBoletasCarrito() {
      var preciosBoletasCarritoMonedaActual = this.$store.getters[
        "carrito/preciosBoletasCarrito"
      ].filter((item) => item.codigo_moneda == this.monedaSelectShopEvento);
      if (
        preciosBoletasCarritoMonedaActual &&
        preciosBoletasCarritoMonedaActual.length > 0
      ) {
        var total = 0;
        for (
          var i = preciosBoletasCarritoMonedaActual.length - 1;
          i >= 0;
          i--
        ) {
          total += preciosBoletasCarritoMonedaActual[i].precio;
        }
        return this.formatNumber(total);
      } else {
        return 0;
      }
    },
    localidadSelectCarrito() {
      return this.$store.getters["carrito/localidadSelectCarrito"];
    },
    countBoletas() {
      return this.$store.getters["carrito/countBoletas"];
      /* var lasBoletas = [];
      var losPalcos = [];

      for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
        if (this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
          if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
            losPalcos = losPalcos.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
          } else {
            lasBoletas = lasBoletas.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
          }
          this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
        }
      }

      return lasBoletas.length; */
    },
    countPalcos() {
      return this.$store.getters["carrito/countPalcos"];
      /* var lasBoletas = [];
      var losPalcos = [];

      for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
        if (this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
          if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
            losPalcos = losPalcos.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
          } else {
            lasBoletas = lasBoletas.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
          }
          this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
        }
      }

      return losPalcos.length;*/
    },
    dateTimeSaleStart() {
      return this.$store.getters["carrito/dateTimeSaleStart"];
    },
    dateTimeSaleEnd() {
      return this.$store.getters["carrito/dateTimeSaleEnd"];
    },
    listLocalidadesEventoAuditorioGeneral_mapeado() {
      const listadoVentaNormal =
        this.$store.getters[
        "auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado"
        ];
      const listadoPreventas =
        this.$store.getters["evento/listPreventasEvento"];
      let listadoFinalPreventas = [];

      for (let i = 0; i < listadoVentaNormal.length; i++) {
        for (let j = 0; j < listadoPreventas.length; j++) {
          if (
            (listadoVentaNormal[i].id_tribuna ==
              listadoPreventas[j].id_tribuna &&
              !listadoFinalPreventas.includes(listadoVentaNormal)) ||
            (listadoVentaNormal[i].id_evento == listadoPreventas[j].id_evento &&
              !listadoFinalPreventas.includes(listadoVentaNormal)) ||
            (listadoVentaNormal[i].id_tribuna ==
              listadoPreventas[j].id_tribuna &&
              !listadoFinalPreventas.includes(listadoVentaNormal))
          ) {
            var tempData = listadoVentaNormal[i];
            tempData.fecha_inicio = listadoPreventas[j].fecha_inicio;
            tempData.fecha_fin = listadoPreventas[j].fecha_fin;
            tempData.total = this.getLocalidadDescuento(
              tempData,
              listadoPreventas[j]
            );
            if (listadoPreventas[j].porcentaje_descuento_precio) {
              tempData.localidad_evento[0].precio_venta =
                (tempData.localidad_evento[0].precio_venta * 100) /
                listadoPreventas[j].porcentaje_descuento_precio;
            } else if (listadoPreventas[j].porcentaje_descuento_servicio) {
              tempData.localidad_evento[0].precio_venta =
                (tempData.localidad_evento[0].precio_venta * 100) /
                listadoPreventas[j].porcentaje_descuento_servicio;
            } else if (
              listadoPreventas[j].precios_monedas[0].descuento_fijo_precio
            ) {
              tempData.localidad_evento[0].precio_venta =
                tempData.localidad_evento[0].precio_venta -
                listadoPreventas[j].precios_monedas[0].descuento_fijo_precio;
            } else if (
              listadoPreventas[j].precios_monedas[0].descuento_fijo_servicio
            ) {
              tempData.localidad_evento[0].precio_venta =
                tempData.localidad_evento[0].precio_venta -
                listadoPreventas[j].precios_monedas[0].descuento_fijo_servicio;
            }
            listadoFinalPreventas.push(tempData);
          }
        }
      }
      return listadoFinalPreventas;
    },
  },
};
</script>
<style scoped>
.v-footer .surfaceContainerLowest .ma-0 {
  z-index: 11;
}

.area_mapeadaAuditorio2 {
  overflow: auto;
  position: relative;
  width: 100vw;
}

/* La imagen se ajusta inicialmente al 100% del ancho */
img[usemap] {
  border: 0;
  width: 100vw;
  height: auto;
}

.calendario {

  background-image: url('/images/vertical.webp');
  background-size: 100% auto;
  width: 100%;
  background-position: top;
  padding: 20px;
  width: 100%
}



.grid-container {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  justify-items: center;
}

.grid-item {

  padding: 20px;
  border-radius: 15px;
  width: 100%;
  max-width: 600px;
}

.funcion-item {
  margin-top: 20px;

  border-radius: 15px;
}

.funcion-row {
  display: flex;
  align-items: center;
  padding: 10px;
}

.funcion__hora {
  width: 250px;
  color: #ffffff;
  background-color: #bf2f35;
  border-radius: 12px 12px 0px 0px;
  padding: 10px;
  flex: 1;
}

.funcion__hora--text {

  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 900 !important;
}

.funcion-detalle {
  flex: 2;
  margin-top: 4px;
  padding: 12px;
  background-color: #f2f2f2;

  h5 {
    font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
    font-weight: 900 !important;
  }
}

.funcion-comprar {
  flex: 1;
  text-align: right;
  padding: 10px;
}

#app {
  min-height: 100svh;
}

#app>div>footer {
  bottom: 0%;
  position: fixed;
  width: 100%;
}

#app>div>header {
  top: 0%;
  position: fixed;
  width: 100%;
  z-index: 15;
}

.v-main-complete {
  height: 100dvh;
  position: relative;
}

.container-antigua {
  width: 100vw;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 8.75rem;
  overflow-y: auto;
}

.container-antigua::-webkit-scrollbar {
  display: none;

}

.panel-overlay {
  bottom: 11rem;
  height: calc(100vh - 17rem);
  overflow: hidden;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 11;
}

.overlay-backdrop {
  position: fixed;
  left: 0;
  bottom: 11rem;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-virtual-scroll {
  height: calc(100vh - 36rem);

}

@media (min-width: 300px) {
  .seleccion_fecha {
    margin-top: 5rem;
    color: #bf2f35;
    padding: 1rem;
    background-color: #f2f2f2;
    border: 1px dashed #bf2f35;
    border-radius: 12px;
    font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
    font-weight: 900 !important;


  }


}

@media (min-width: 600px) {
  .panel-overlay {
    bottom: 6.75rem;

  }

  .overlay-backdrop {

    bottom: 6.75rem;


  }
}

@media (min-width: 720px) {
  .calendario {
    background-image: url('/images/horizontal.webp');

  }

  .v-virtual-scroll {
    height: calc(100vh - 40rem);

  }
}

@media (min-width: 960px) {
  .container-antigua {
    height: 100vh;
    top: 0;
    bottom: 0;
    position: relative;
    width: calc(100vw - 25rem);
  }



  .v-main-complete {
    height: 100%;
  }

  .v-virtual-scroll {
    height: calc(100vh - 28rem);

  }

}

@media (min-width: 960px) and (max-width: 1263px) {
  .v-navigation-drawer.v-navigation-drawer--close.v-navigation-drawer--right {
    height: 100vh;
    top: 64px !important;
    transform: translateX(0px) !important;
    visibility: visible !important;
    max-height: calc(100% - 64px);
  }

  .v-navigation-drawer__content {
    height: 100%;
  }



}
</style>

<style>
div.contenedor-todo {
  height: 100%;
  width: 100%;
}

#app>div>header[data-v-5f34cd6a] {
  z-index: 10;
}

.barraNavegacionServicios {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 1fr 0.5fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  align-items: center;
  justify-items: stretch;


  .atras {
    grid-area: 1 / 1 / 2 / 2;
    padding-left: 1rem;
  }

  .nav-info {
    grid-area: 1 / 2 / 2 / 3;
  }

  .avatar {
    grid-area: 1 / 3 / 2 / 4;
    padding-right: 1.5rem;
  }

  .paso {
    grid-area: 2 / 1 / 3 / 4;
  }

}


.container-select {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0.8fr 1fr;
  gap: 0px 0px;

  height: 100dvh;
}

/*
.version-map2 {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 2fr 1fr;
  gap: 16px 0px;
  grid-auto-flow: row;
   grid-template-areas:
      "select-map2 zoom "
      "select-seat2";
  grid-area: 1 / 1 / 2 / 2;
  height: 100%;
  overflow-y: auto;
  justify-items: center;

  .select-map2 {
    grid-area: select-map2;
  }

  .select-seat2 {
    grid-area: select-seat2;
  }
}

*/

div.zoomControl {
  position: fixed;
  z-index: 4;
  right: 1em;
}

.version-map1 {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0.8fr 0.5fr min-content;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "select-map"
    "select-seat"
    "select-place";
  grid-area: 1 / 1 / 2 / 2;
  height: calc(100dvh - 5rem);
  align-content: center;

  .select-map {
    justify-self: stretch;
    align-self: stretch;
    grid-area: select-map;
    padding-top: 1rem;

  }

  .select-seat {
    grid-area: select-seat;
  }

  .select-place {
    grid-area: select-place;

  }


}

.info-total-small {
  grid-area: 2 / 1 / 3 / 2;
  align-self: stretch;
  z-index: 11;
}

.vselect {
  z-index: 5;
}


.info-select {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: subgrid;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "info-select-number info-select-delete"
    "info-select-seating info-select-seating";
  grid-area: info-select;
  align-items: start;
  padding: 1rem;

}

.info-select-number {
  grid-area: info-select-number;
  align-self: center;

}

.info-select-delete {
  grid-area: info-select-delete;
  align-self: center;
}

.info-select-seating {
  grid-area: info-select-seating;
}

.info-event {
  grid-area: info-event;
}





.imp-img-map {
  width: 25rem;
  height: 30rem;
  object-fit: cover;
}



.page-container {
  position: relative;

}


.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


@media (min-width: 960px) {
  div.zoomControl {
    right: 27em;
  }

  div.contenedor-todo {
    width: calc(100vw - 8px)
  }

  .container-select {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    overflow: hidden;
    height: 100vh;
    background-color: #FDF8F8;

  }

  .v-navigation-drawer {
    width: 25rem !important;
  }

  .sidebar {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: min-content minmax(380px, 1fr) min-content;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas:
      "info-event"
      "info-select"
      "info-total-large";
    grid-area: 1 / 2 / 2 / 3;
    height: 100%;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0.0625rem, rgba(0, 0, 0, 0.1) 0px 0.125rem 0.5rem;
    z-index: 5;
  }

  .info-select {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: min-content 1fr;
    grid-auto-flow: row;
    grid-template-areas:
      "info-select-number info-select-delete"
      "info-select-seating info-select-seating";
    grid-area: info-select;
  }

  .info-select-number {
    grid-area: info-select-number;
  }

  .info-select-delete {
    grid-area: info-select-delete;
  }

  .info-select-seating {
    grid-area: info-select-seating;
  }

  .info-event {
    grid-area: info-event;
    padding: 1rem;
    margin: 1rem 0 1rem 0;
  }

  .info-total-large {
    grid-area: info-total-large;
    padding: 1rem;
    margin: 1rem 0 1rem 0;
    align-self: end;
    z-index: 999;
  }

  .version-map2 {
    display: grid;
    grid-template-columns: 1.8fr 0.1fr;
    grid-template-rows: 1.4fr 0.6fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas:
      "select-map2 zoom "
      "select-seat2";
    grid-area: 1 / 1 / 2 / 2;
    height: 100%;
    align-content: stretch;
    justify-content: stretch;
  }

  .select-map2 {
    grid-area: select-map2;
  }

  .select-seat2 {
    grid-area: select-seat2;
    align-self: stretch;
  }

  .responsive-img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .version-map1 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: minmax(72px, 0.05fr) minmax(480px, 1fr) minmax(200px, 0.5fr);

    gap: 8px 0px;
    grid-auto-flow: row;
    grid-template-areas:
      "select-place"
      "select-map"
      "select-seat";
    grid-area: 1 / 1 / 2 / 2;
    height: 100%;
    overflow-y: scroll;
    padding: 1rem;


    .select-map {
      grid-area: select-map;
      overflow: hidden;
      height: auto;
      width: 100%;
    }

    .select-seat {
      grid-area: select-seat;

    }

  }








  /*Imagen Map pro*/

  #image-map-pro>div.imp-container {
    width: 100% !important;
    justify-content: center;
  }

  #image-map-pro>div>div>div.imp-canvas-wrap>div,
  .imp-img-map {

    max-width: 37.5rem !important;
    width: 30rem !important;
    height: auto !important;

  }

  #image-map-pro>div>div>div.imp-ui>div.imp-ui-bottom-left>div {
    width: 7rem !important;
    height: auto !important;
  }


}

@media (min-width: 1264px) {
  div.zoomControl {
    right: 28em;
  }


  /*Imagen Map pro*/

  #image-map-pro>div>div>div.imp-canvas-wrap>div,
  .imp-img-map {

    max-width: 47rem !important;
    width: 38rem !important;


  }

  #image-map-pro>div>div>div.imp-ui>div.imp-ui-bottom-left>div {
    width: 8.5rem !important;
    height: auto !important;
  }
}

@media (min-width: 1960px) {
  /*Imagen Map pro*/

  #image-map-pro>div>div>div.imp-canvas-wrap>div,
  .imp-img-map {

    max-width: 47rem !important;
    width: 41rem !important;
    align-self: center;


  }

  #image-map-pro>div>div>div.imp-ui>div.imp-ui-bottom-left>div {
    width: 8.5rem !important;
    height: auto !important;
  }
}















.skeleton-banner-principal-evento {
  height: 100%;
  aspect-ratio: 880/448;
}

.img-skeleton .v-skeleton-loader__image {
  height: 500px;
}

.skeleton-banner-principal-evento .v-skeleton-loader .v-skeleton-loader__image,
.skeleton-banner-principal-evento .v-skeleton-loader {
  height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
  align-items: stretch;
  justify-content: center;

}
</style>